import { useState } from 'react'
import { MarkerPin01Icon } from '@/components/ui/icons'
import { QueueFilterSelect } from '@/features/luxe-submissions/components/queue-filter-select'
import type { Location } from '@/features/luxe-submissions/types'
import { useGetLocations } from '../queries/use-get-locations'

const getLocationLabel = (item: Location) =>
	[item.city, item.state, item.countryCode].filter(Boolean).join(', ')

interface FilterLocationSelectProps {
	onChange: (locationId: string | null) => void
	selectedId: string | null
}

function FilterLocationSelect({
	selectedId,
	onChange
}: FilterLocationSelectProps) {
	const [locationSearch, setLocationSearch] = useState('')

	const {
		remappedData: locationsData,
		isLoading: isLoadingLocations,
		isFetchingNextPage: isFetchingNextLocations,
		hasNextPage: hasNextLocations,
		fetchNextPage: fetchNextLocations
	} = useGetLocations(locationSearch)

	const locationsOptions = locationsData.filter(
		(location) => location.city || location.state || location.countryCode
	)
	return (
		<QueueFilterSelect
			fetchNextPage={fetchNextLocations}
			getItemId={(item: Location) =>
				item.city || item.state || item.countryCode || ''
			}
			getItemLabel={getLocationLabel}
			hasNextPage={hasNextLocations}
			icon={<MarkerPin01Icon size={20} />}
			isFetchingNextPage={isFetchingNextLocations}
			isLoading={isLoadingLocations}
			items={locationsOptions}
			onChange={onChange}
			onSearch={setLocationSearch}
			placeholder='Location'
			value={selectedId}
		/>
	)
}
export { FilterLocationSelect }
